module.exports = __webpack_public_path__ + "static/media/theracer-small.ca518f44.png";